<section class="experience_section">
    <div class="home__container containerPersonal grid">
        <div class="home__content grid">
            <div class="home__data">
                <h1 class="home__title">Nuestros Proyectos</h1>
                <div class="card-container">
                    <!-- Tarjeta de proyecto -->
                  
                    <a class="card" (click)="openModal('project1')">
                        <img src="assets/img/Proyecto2.jpg" alt="Sistema Biométrico" class="project-image" style="width: 100%;height: 200px; object-fit: cover;">
                        <div class="card-content">
                            <h3 class="home__subtitle">Sistema de Autenticación Biométrica</h3>
                            <p class="project-description">Plataforma web con autenticación facial y huella dactilar para sector financiero</p>
                        </div>
                    </a>
                    <a class="card" (click)="openModal('project2')">
                        <img src="assets/img/Proyecto3.jpg" alt="IoT Industrial" class="project-image" >
                        <div class="card-content">
                            <h3 class="home__subtitle">Solución IoT Industrial</h3>
                            <p class="project-description">Sistema de monitoreo y control para procesos industriales automatizados</p>
                        </div>
                    </a>
                    <a class="card" (click)="openModal('project3')">
                        <img src="assets/img/Proyecto4.jpg" alt="Portal Corporativo" class="project-image" style="width: 100%;height: 200px; object-fit: cover;">
                        <div class="card-content">
                            <h3 class="home__subtitle">Portal de Gestión Empresarial</h3>
                            <p class="project-description">Aplicación web para gestión de contratos y documentos corporativos</p>
                        </div>
                    </a>
                    <a class="card" (click)="openModal('project4')">
                        <img src="assets/img/Proyecto1.jpg" alt="Microservicios" class="project-image">
                        <div class="card-content">
                            <h3 class="home__subtitle">Arquitectura de Microservicios</h3>
                            <p class="project-description">Migración de monolito a microservicios con Spring Boot y AWS</p>
                        </div>
                    </a>
                    <a class="card" (click)="openModal('project5')">
                        <img src="assets/img/Proyecto5.jpg" alt="Sistema Logístico" class="project-image">
                        <div class="card-content">
                            <h3 class="home__subtitle">Sistema de Logística Inteligente</h3>
                            <p class="project-description">Plataforma de seguimiento y optimización de cadena de suministro</p>
                        </div>
                    </a>
                   
                </div>
            </div>
        </div>
    </div>

    <!-- Modales -->
    <div class="modal" [class.active]="activeModal === 'project1'">
        <div class="modal-content">
            <span class="close" (click)="closeModal()">&times;</span>
            <h2>Sistema de Autenticación Biométrica</h2>
            <p>Desarrollo integral de una plataforma web con tecnología de reconocimiento facial y huella dactilar 
            para el sector financiero. Implementación de APIs RESTful con Spring Boot, interfaces de usuario 
            responsivas con Angular, y medidas de seguridad avanzadas para el manejo de datos biométricos.</p>
            <h4>Tecnologías:</h4>
            <div class="tech-stack">
                <span class="tech-item">Java</span>
                <span class="tech-item">Spring Boot</span>
                <span class="tech-item">Angular</span>
                <span class="tech-item">MySQL</span>
                <span class="tech-item">AWS</span>
            </div>
        </div>
    </div>

    <div class="modal" [class.active]="activeModal === 'project2'">
        <div class="modal-content">
            <span class="close" (click)="closeModal()">&times;</span>
            <h2>Solución IoT Industrial</h2>
            <p>Sistema completo de Internet de las Cosas para monitoreo y control de procesos industriales. 
            Incluye sensores inteligentes, dashboard en tiempo real, alertas automáticas y análisis predictivo 
            para optimización de operaciones industriales.</p>
            <h4>Tecnologías:</h4>
            <div class="tech-stack">
                <span class="tech-item">Python</span>
                <span class="tech-item">Node.js</span>
                <span class="tech-item">React</span>
                <span class="tech-item">PostgreSQL</span>
                <span class="tech-item">Azure IoT</span>
            </div>
        </div>
    </div>

    <div class="modal" [class.active]="activeModal === 'project3'">
        <div class="modal-content">
            <span class="close" (click)="closeModal()">&times;</span>
            <h2>Portal de Gestión Empresarial</h2>
            <p>Aplicación web completa para la gestión de contratos, documentos y procesos corporativos. 
            Incluye workflow automatizado, firma digital, notificaciones inteligentes y reportería avanzada 
            para mejorar la eficiencia operacional.</p>
            <h4>Tecnologías:</h4>
            <div class="tech-stack">
                <span class="tech-item">Angular</span>
                <span class="tech-item">Node.js</span>
                <span class="tech-item">Express</span>
                <span class="tech-item">SQL Server</span>
                <span class="tech-item">Azure</span>
            </div>
        </div>
    </div>

    <div class="modal" [class.active]="activeModal === 'project4'">
        <div class="modal-content">
            <span class="close" (click)="closeModal()">&times;</span>
            <h2>Arquitectura de Microservicios</h2>
            <p>Migración completa de aplicación monolítica a arquitectura de microservicios. Implementación 
            de API Gateway, service discovery, circuit breakers y observabilidad completa. Despliegue 
            automatizado con Docker y Kubernetes en AWS.</p>
            <h4>Tecnologías:</h4>
            <div class="tech-stack">
                <span class="tech-item">Java</span>
                <span class="tech-item">Spring Boot</span>
                <span class="tech-item">Docker</span>
                <span class="tech-item">Kubernetes</span>
                <span class="tech-item">AWS EKS</span>
            </div>
        </div>
    </div>

    <div class="modal" [class.active]="activeModal === 'project5'">
        <div class="modal-content">
            <span class="close" (click)="closeModal()">&times;</span>
            <h2>Sistema de Logística Inteligente</h2>
            <p>Plataforma integral para optimización de cadena de suministro con tracking en tiempo real, 
            predicción de demanda, gestión de inventarios y optimización de rutas. Incluye dashboards 
            ejecutivos y API para integración con sistemas externos.</p>
            <h4>Tecnologías:</h4>
            <div class="tech-stack">
                <span class="tech-item">React</span>
                <span class="tech-item">Python</span>
                <span class="tech-item">Django</span>
                <span class="tech-item">PostgreSQL</span>
                <span class="tech-item">Machine Learning</span>
            </div>
        </div>
    </div>
</section>